import { ApiService } from "../apiService";

export class VehiclesService extends ApiService {
    constructor() {
        super();

        this.path = '/Vehicles';
    }

    getVehicles() {
        return this.get(this.path);
    }

    getNoLinked() {
        return this.get(this.path + "/notlinked");
    }

    getNotLinkedById(id){
        return this.getById(this.path + '/notLinkedById', id)
    }

    getVehicle(vehicleId) {
        return this.getById(this.path, vehicleId);
    }

    getAllPlates(id) {
        return this.getById(this.path + "/getAllPlates", id);
    }

    getPlatesByBlueprint(id, list) {
        return this.getVehiclesByBlueprint(this.path, id, list);
    }

    createVehicle(newVehicle, typeGrid) {
        return this.post(this.path, newVehicle, typeGrid);
    }

    updateVehicle(updatedVehicle) {
        return this.put(this.path, updatedVehicle);
    }

    deleteVehicle(id) {
        return this.delete(this.path, id);
    }

    undoVehicle(idVehicle) {
        return this.postUndo(this.path + "/undoDeleteVehicle", idVehicle);
    }
}